import { render, staticRenderFns } from "./CustomerCard2.vue?vue&type=template&id=36aacd1c&scoped=true"
import script from "./CustomerCard2.vue?vue&type=script&lang=js"
export * from "./CustomerCard2.vue?vue&type=script&lang=js"
import style0 from "./CustomerCard2.vue?vue&type=style&index=0&id=36aacd1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aacd1c",
  null
  
)

export default component.exports